import React from 'react';

export const Rename = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.83341 3.3335H7.16675V5.00016H4.66675C4.00371 5.00016 3.36782 5.26355 2.89898 5.7324C2.43014 6.20124 2.16675 6.83712 2.16675 7.50016V12.5002C2.16675 13.1632 2.43014 13.7991 2.89898 14.2679C3.36782 14.7368 4.00371 15.0002 4.66675 15.0002H7.16675V16.6668H8.83341V3.3335ZM7.16675 6.66683V13.3335H4.66675C4.44573 13.3335 4.23377 13.2457 4.07749 13.0894C3.92121 12.9331 3.83341 12.7212 3.83341 12.5002V7.50016C3.83341 7.27915 3.92121 7.06719 4.07749 6.91091C4.23377 6.75463 4.44573 6.66683 4.66675 6.66683H7.16675Z"
      fill={color || '#6E6B8C'}
    />
    <path
      d="M16.3333 13.3333H10.5V15H16.3333C16.9964 15 17.6323 14.7366 18.1011 14.2678C18.5699 13.7989 18.8333 13.163 18.8333 12.5V7.5C18.8333 6.83696 18.5699 6.20107 18.1011 5.73223C17.6323 5.26339 16.9964 5 16.3333 5H10.5V6.66667H16.3333C16.5543 6.66667 16.7663 6.75446 16.9226 6.91074C17.0789 7.06702 17.1667 7.27899 17.1667 7.5V12.5C17.1667 12.721 17.0789 12.933 16.9226 13.0893C16.7663 13.2455 16.5543 13.3333 16.3333 13.3333Z"
      fill={color || '#6E6B8C'}
    />
  </svg>
);
